// import { Button } from 'rsuite';
import { useUser } from '../../contexts/user';
import DoctorVisitsImage from '../../assets/icons/get_doctor_visit.svg';
import NoDoctorImage from '../../assets/icons/no_doctor.svg';
import DoctorImage from '../../assets/icons/doctor_vector_black.svg';
import LocationImage from '../../assets/icons/location.svg';
import PhoneImage from '../../assets/icons/phone_call.svg';
import FileImage from '../../assets/icons/file_info.svg';
import { FofLogin } from '../../components/basic/fof-login';
import { useQuery } from 'react-query';
import { IMAGE_BASE_URL, getDoctorsInExpertise } from '../../core';
import { DoctorModel } from '../../models/models';
import { CustomLoader } from '../../components/basic/loader';
import { useNavigate, useParams } from 'react-router-dom';
export const DoctorsInExpertise = () => {
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();
  const { user } = useUser();
  const { id } = useParams();

  const doctors = useQuery({
    queryKey: ['doctors-in-expertise', id, 1],
    queryFn: async () => {
      const res = await getDoctorsInExpertise(parseInt(id ?? ''), 1);
      return res.data.data;
    }
  });
  return (
    <>
      {user.isLoggedIn ? (
        <div className="px-3 pt-5 pb-5 text-base1 text-justify bg-[--rs-gray-50] h-full">
          {doctors.isLoading ? (
            <CustomLoader />
          ) : (
            <>
              {doctors.data.map((doctor: DoctorModel) => {
                return (
                  <div
                    key={doctor.id.toString()}
                    onClick={() => {
                      navigate(`/reserve/${doctor.id}`);
                    }}
                    className="flex flex-col shadow-[0_1px_3px_0px_rgba(0,0,0,0.1)] p-2 mb-3 rounded-md bg-[--rs-white] cursor-pointer">
                    <div className="flex justify-between">
                      <img
                        className="w-[40%] h-fit m-auto"
                        style={{ aspectRatio: 623 / 523 }}
                        src={`${IMAGE_BASE_URL}/${doctor.image_of_doctor}`}
                        alt={doctor.doctor_name}
                      />
                      <div className="w-[60%] flex flex-col text-sm justify-between px-2 mt-1">
                        <div className="mb-2 flex text-base1">
                          <img className="w-5 ml-2" src={DoctorImage} alt="" />
                          <span>
                            {doctor.doctor_name} {doctor.doctor_family}
                          </span>
                        </div>
                        <div className="mb-2 flex text-sm">
                          <img className="w-5 ml-2" src={LocationImage} alt="" />
                          <span>{doctor.office_address}</span>
                        </div>
                        <div className="mb-2 flex text-sm">
                          <img className="w-5 ml-2" src={PhoneImage} alt="" />
                          <span>{doctor.office_phone_number}</span>
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 flex text-sm">
                      <img className="w-5 ml-2" src={FileImage} alt="" />
                      <span>{doctor.write_about_yourself}</span>
                    </div>
                  </div>
                );
              })}
              {doctors.data.length === 0 ? (
                <FofLogin
                  image={NoDoctorImage}
                  backMode={true}
                  imageCustomSize={50}
                  text="در این دسته بندی پزشکی برای گرفتن نوبت ویزیت وجود ندارد. به زودی پزشکان این بخش به برنامه افزوده می شوند."
                  redirect="/"
                />
              ) : null}
            </>
          )}
        </div>
      ) : (
        <FofLogin
          startFromTop={true}
          image={DoctorVisitsImage}
          text="در این قسمت شما میتوانید از بین تخصص های مختلف پزشکان هر دسته را مشاهده کنید و پس از انتخاب تاریخ ویزیت، اگر در آن روز نوبت ویزیت خالی وجود داشته باشد اقدام به گرفتن نوبت حضوری کنید."
          redirect="/expertise"
        />
      )}
    </>
  );
};
